import { Box, Typography } from '@mui/material';

const ApercibidosStatusIcon = ({ iconWidth, iconHeight, color, hide, styles = {} }) => {
    if (hide === true) return null;
    return (
        <Box
            style={{
                width: iconWidth ?? 20,
                height: iconHeight ?? 20,
                background: color ?? 'rgb(255 243 106)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '4px',
                border: '1px solid rgba(0,0,0,0.2)',
                position: 'relative',
                zIndex: 1,
                ...styles,
            }}
            className="apercibidos-status-icon"
        >
            <Typography
                style={{ margin: 0, padding: 0, fontSize: '12px', color: '#000', fontWeight: 500 }}
                component={'span'}
            >
                4
            </Typography>
        </Box>
    );
};

export default ApercibidosStatusIcon;
